import { getFullAPIFileURL } from '../../common/getFullAPIFileURL';

/**
 * The serialized file url is relative (`files/<uuid>/download`), so used as-is
 * it resolves against the app's own path and 404s. This resolves it against
 * music24-api's same-origin base (`/api_api/`) and asks for inline delivery, which is what a <video>, <audio>
 * or <img> element needs — the endpoint's default is a download.
 */
export function inlineMediaUrl(url: string): string {
  const absolute = getFullAPIFileURL(url);
  return absolute.includes('?') ? `${absolute}&disposition=inline` : `${absolute}?disposition=inline`;
}

/**
 * The same absolute url with the endpoint's default download disposition. The server names the
 * file in its `Content-Disposition` ("LaziiBee - Forests - Story (Out now) - Noir.jpg", fym-shared
 * `kitFileNames.ts`), and a same-origin `<a download>` with no value saves it under that name.
 */
export function downloadMediaUrl(url: string): string {
  return getFullAPIFileURL(url);
}
